export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_MEDICATION":
      return [...state, action.payload.medication];
    case "UPDATE_MEDICATIONS":
      return action.payload.medications;
    case "DELETE_MEDICATION":
      return state.filter((medication) => {
        return medication.id !== action.payload.medication.id
      });
    default:
      return state;
  }
}
